module.exports = __webpack_public_path__ + "static/img/hot-tag-ico.069402d.png";